export { CardHorizontalMini, CardHorizontalMiniConfig } from './CardHorizontalMini';
